import { ListItem, ListItemText } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';

const useStyles = makeStyles()((theme) => ({
  text: {
    padding: '0 !important',
  },
  item: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(0.5),

    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
  },
}));

function SimpleListItem({ children }: { children: React.ReactNode }) {
  const { classes } = useStyles();
  return (
    <ListItem disableGutters className={classes.item}>
      <ListItemText className={classes.text} primary={children} />
    </ListItem>
  );
}

export default SimpleListItem;
